export default "__VITE_ASSET__Cg3yrSWO__"